import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import {
  Button,
  Form,
  Label,
  Input,
  Col,
  Table,
  Popover,
  PopoverBody,
} from 'reactstrap'
import { StyledTitle } from './App'
import { reduxForm, Field, formValueSelector } from 'redux-form'
import { required } from './common/validation'
import TextField from './common/TextField'
import SelectField from './common/SelectField'
import axios from 'axios'
import { isEmpty } from 'lodash'
import { getFullnameByCuit } from '../requests/afip'
import { getProductCedulas } from '../requests/product'
import config from '../config'
import { addDays } from 'date-fns'
import DatePicker, { registerLocale, setDefaultLocale } from 'react-datepicker'
import es from 'date-fns/locale/es'
import 'react-datepicker/dist/react-datepicker.css'
import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/src/sweetalert2.scss'
import excludes from '../helpers/excludes'
import domains from '../helpers/domains'

const selector = formValueSelector('wizard')
registerLocale('es', es)
setDefaultLocale('es')

function addMonths(date, months) {
  var d = date.getDate();
  date.setMonth(date.getMonth() + +months);
  if (date.getDate() != d) {
    date.setDate(0);
  }
  return date;
}

class StepTwo extends Component {
  state = {
    popoverOpen: {},
    showError: false,
    data: [],
    service: 0,
    countCedula: 0,
    costoGestion: 199,
    costoPlus: 50,
    typeDni: '',
    aTypeDni: '',
    typeCedula: 0,
    selectedTypes: [],
    typePerson: '',
    valueDate: '',
    minDate: new Date(),
    maxDate: addMonths(new Date(), 1),
    accepted: false,
    showErrorNotAccepted: false,
    showErrorCed: false,
    showErrorNoDate: false,
    showErrorSameTitAuth: false,
    myRef: React.createRef(),
    showExpediciónCedula: true,
    showRevocCedulaAzul: false,
    showRenovationCedulaVerde: false,
    showDuplicateCedulaVerde: false,
    showExpedicionCedulaVerde: false,
    priceRenovation: 199,
    priceDuplicate: 199,
    arancelRenovation: {
      arancel: 325,
      renovation: 335,
      multa: 135,
      form13: 222,
    },
    arancelDuplication: {
      arancel: 325,
      duplicate: 335,
      multa: 135,
      form13: 222,
    },
    expeditionCedulaAzul: {
      cedulaAuthorization: 385,
      arancel: 375,
      formulariotp: 258,
      bonif: 258,
      multa: 135,
      formulario13: 222,
    },
    arancelCedulaVerde: {
      cedulaAuthorization: 335,
      arancel: 325,
      formulariotp: 228,
      bonif: 228,
      multa: 135,
      formulario13: 222,
    },
    typesDniFisica: [
      {
        id: '1',
        type: 'DNI',
      },
      {
        id: '2',
        type: 'Libreta de Enrolamiento',
      },
      {
        id: '3',
        type: 'Libreta Cívica',
      },
      {
        id: '4',
        type: 'DNI Extranjero',
      },
      {
        id: '5',
        type: 'Cedula de identidad Extranjero',
      },
      {
        id: '6',
        type: 'Pasaporte',
      },
      {
        id: '7',
        type: 'CUIT / CUIL',
      },
    ],
    typesMotive: [
      {
        id: '1',
        type: 'EXTRAVIO',
      },
      {
        id: '2',
        type: 'ROBO Y/O HURTO',
      },
      {
        id: '3',
        type: 'DETERIORO',
      },
      {
        id: '4',
        type: 'DESTRUCCIÓN',
      },
    ],
    typesDniJuridica: [
      {
        id: '7',
        type: 'CUIT',
      },
    ],
  }

  async componentDidMount() {
    // const resultCedulaAzul = await getProductCedulas(6);
    // const resultCedulaVerde = await getProductCedulas(8);
    let amountCedulaAzul = 249
    let amountCedulaVerde = 249

    if (this.props.a_dni_type === undefined) {
      this.props.change('a_dni_type', '1')
      this.props.untouch('a_dni_type')
    }

    if (this.props.product == 'cedula-azul') {
      this.setState({
        costoGestion: amountCedulaAzul,
      })
    }

    if (this.props.product == 'revocacion-cedula-azul') {
      this.setState({
        showRevocCedulaAzul: true,
        showExpediciónCedula: false,
        showDuplicateCedulaVerde: false,
        showExpedicionCedulaVerde: false,
        showRenovationCedulaVerde: false,
        costoGestion: amountCedulaAzul,
      })
    }

    if (this.props.product == 'renovate-cedula-verde') {
      this.setState({
        showExpediciónCedula: false,
        showDuplicateCedulaVerde: false,
        showExpedicionCedulaVerde: false,
        showRevocCedulaAzul: false,
        showRenovationCedulaVerde: true,
        costoGestion: amountCedulaVerde,
      })
    }

    if (this.props.product == 'duplicate-cedula-verde') {
      this.setState({
        showExpediciónCedula: false,
        showRenovationCedulaVerde: false,
        showExpedicionCedulaVerde: false,
        showRevocCedulaAzul: false,
        showDuplicateCedulaVerde: true,
        costoGestion: amountCedulaVerde,
      })
    }

    if (this.props.product == 'cedula-verde') {
      this.setState({
        showExpediciónCedula: false,
        showRenovationCedulaVerde: false,
        showExpedicionCedulaVerde: true,
        showDuplicateCedulaVerde: false,
        showRevocCedulaAzul: false,
        typeCedula: 1,
        costoGestion: amountCedulaVerde,
      })
    }

    const typeRodado = domains.getTypeRodadoByDomain(this.props.patent)

    if (typeRodado.auto.length > 0 && typeRodado.moto.length == 0) {
      this.setState({
        expeditionCedulaAzul: {
          cedulaAuthorization: 945,
          arancel: 0,
          formulariotp: 0,
          bonif: 0,
          multa: 0,
          formulario13: 0,
        },
      })
    }

    if (typeRodado.auto.length == 0 && typeRodado.moto.length > 0) {
      this.setState({
        expeditionCedulaAzul: {
          cedulaAuthorization: 540,
          arancel: 0,
          formulariotp: 0,
          bonif: 0,
          multa: 0,
          formulario13: 0,
        },
      })
    }

    if (typeRodado.auto.length > 0 && typeRodado.moto.length == 0) {
      this.setState({
        arancelRenovation: {
          arancel: 945,
          renovation: 0,
          formulariotp: 0,
          bonif: 0,
          multa: 0,
          form13: 0,
        },
      })
    }

    if (typeRodado.auto.length == 0 && typeRodado.moto.length > 0) {
      this.setState({
        arancelRenovation: {
          arancel: 540,
          renovation: 0,
          formulariotp: 0,
          bonif: 0,
          multa: 0,
          form13: 0,
        },
      })
    }

    if (typeRodado.auto.length > 0 && typeRodado.moto.length == 0) {
      this.setState({
        arancelCedulaVerde: {
          cedulaAuthorization: 1447,
          arancel: 0,
          formulariotp: 0,
          bonif: 0,
          multa: 0,
          formulario13: 0,
        },
      })
    }

    if (typeRodado.auto.length == 0 && typeRodado.moto.length > 0) {
      this.setState({
        arancelCedulaVerde: {
          cedulaAuthorization: 1007,
          arancel: 0,
          formulariotp: 0,
          bonif: 0,
          multa: 0,
          formulario13: 0,
        },
      })
    }

    if (typeRodado.auto.length > 0 && typeRodado.moto.length == 0) {
      this.setState({
        arancelDuplication: {
          cedulaAuthorization: 1447,
          arancel: 0,
          formulariotp: 0,
          bonif: 0,
          multa: 0,
          formulario13: 0,
        },
      })
    }

    if (typeRodado.auto.length == 0 && typeRodado.moto.length > 0) {
      this.setState({
        arancelDuplication: {
          cedulaAuthorization: 1007,
          arancel: 0,
          formulariotp: 0,
          bonif: 0,
          multa: 0,
          formulario13: 0,
        },
      })
    }

    const now = new Date()
    const end = new Date()

    this.setState({
      service: 0,
    })

    this.setState({
      maxDate: end.setDate(now.getDate() + 31),
    })

    this.setState({
      selectedTypes: this.state.typesDniFisica,
    })
    if (this.props.step1_caracter == 'titular') {
      this.props.change('step2_dni_type', '7')
      this.props.change('t_cuit_cuil', this.props.step1_cuit)
    }

    if (now.getDay() == 6) {
      this.setState({
        minDate: addDays(this.state.minDate, 2),
      })
    } else {
      if (now.getHours() >= 12) {
        if (addDays(now, 1).getDay() == 5) {
          this.setState({
            minDate: addDays(this.state.minDate, 3),
          })
        } else {
          this.setState({
            minDate: addDays(this.state.minDate, 1),
          })
        }
      }
    }

    this.setState({
      typePerson: 'fisica',
    })

    this.setState({
      showError: false,
    })

    this.calculatePrice()

    window.scrollTo(0, 0)
  }

  toggle = (name) => {
    this.setState({
      popoverOpen: {
        [name]: !this.state.popoverOpen[name],
      },
    })
  }

  validateDniOne = (value) => {
    if (this.props.step2_dni_type == '1') {
      return this.validateDni(value)
    }

    if (this.props.step2_dni_type == '7') {
      return this.validateCuit(value)
    }
  }

  validateDniTwo = (value) => {
    if (this.props.a_dni_type == '1') {
      return this.validateDni(value)
    }

    if (this.props.a_dni_type == '7') {
      return this.validateCuit(value)
    }
  }

  validateDni = (value) => {
    if (isEmpty(value)) return 'Campo requerido'

    if (String(value.length) < 7) return 'Dni debe ser mayor a 6 digitos'

    if (String(value.length) > 8) return 'Dni debe ser menor 8 digitos'

    return undefined
  }

  validateCuit = (value) => {
    var mult = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2]
    var total = 0
    var cuit = []

    value = value ? value.toString().replace(/-/g, '') : ''

    if (value.match(/[a-z]/i)) {
      return 'El cuit tiene un formato inválido'
    }

    for (var x = 0; x < value.length; x++) {
      if (value.substr(x, 1) !== '') {
        cuit[x] = value.substr(x, 1)
      }
    }

    if (cuit.length == 0) return undefined

    if (cuit.length == 11) {
      var prim = cuit[0] + cuit[1]
      if (
        prim == 27 ||
        prim == 20 ||
        prim == 23 ||
        prim == 30 ||
        prim == 33 ||
        prim == 34 ||
        prim == 24
      ) {
        for (var i = 0; i < mult.length; i++) {
          total += parseInt(cuit[i]) * mult[i]
        }
        var mod = total % 11
        var digito = mod == 0 ? 0 : mod == 1 ? 9 : 11 - mod

        if (digito == parseInt(cuit[10])) {
          return undefined
        } else {
          return 'El cuit tiene un formato inválido'
        }
      } else {
        return 'El cuit tiene un formato inválido'
      }
    } else {
      return 'El cuit tiene un formato inválido'
    }
  }

  handleChangeDni = (event) => {
    this.setState({ typeDni: event.target.value })
  }

  handleChangeADni = (event) => {
    this.setState({ aTypeDni: event.target.value })
  }

  checkCorrectData = (dniType, number) => {
    if (dniType == 7) {
      return this.validateCuit(number)
    }

    if (dniType == 1) {
      return this.validateDni(number)
    }
  }

  handleAddCedule = (e) => {
    e.preventDefault()
    e.stopPropagation()

    const costoGestion = this.state.costoGestion
    const costoPlus = this.state.costoPlus
    let cost = 0

    if (this.checkCorrectData(this.props.a_dni_type, this.props.a_cuit_cuil)) {
      return
    }

    if (this.isSameTitularToAutorized()) {
      this.setState({
        showErrorSameTitAuth: true,
      })
      return
    } else {
      this.setState({
        showErrorSameTitAuth: false,
      })
    }

    if (
      this.existSameDocNumber(
        this.setNameDoc(this.props.a_dni_type),
        this.props.a_cuit_cuil
      )
    ) {
      this.setState({
        showErrorCed: true,
      })
      return
    } else {
      this.setState({
        showErrorCed: false,
      })
    }

    if (
      !this.props.a_cuit_cuil ||
      !this.props.a_dni_type ||
      !this.props.a_firstname ||
      !this.props.a_lastname
    )
      return

    if (this.state.showError) {
      this.setState({
        showError: false,
      })
    }

    this.props.changeData({
      cuitCuil:
        this.props.a_cuit_cuil.length === 7 && this.props.a_dni_type == '1'
          ? `0${this.props.a_cuit_cuil}`
          : this.props.a_cuit_cuil,
      dniType: this.setNameDoc(this.props.a_dni_type),
      firstname: this.props.a_firstname,
      lastname: this.props.a_lastname,
      typeCedula: this.state.typeCedula == 0 ? 'cedula-azul' : 'cedula-verde',
    })

    if (this.state.countCedula == 0) {
      cost = costoGestion
      this.setState({ service: cost })
    } else if (this.state.countCedula > 1) {
      cost = this.state.service + costoPlus
      this.setState({ service: cost })
    }

    this.props.change('a_cuit_cuil', '')
    this.props.untouch('a_cuit_cuil')
    this.props.change('a_dni_type', '1')
    this.props.untouch('a_dni_type')
    this.props.change('a_firstname', '')
    this.props.untouch('a_firstname')
    this.props.change('a_lastname', '')
    this.props.untouch('a_lastname')
    this.setState({
      countCedula: this.state.countCedula + 1,
    })

    const heigthFirstElement = document.getElementById('btn-solicitud-mobile')
      .clientHeight

    window.scrollTo(0, heigthFirstElement)
  }

  calculatePrice = () => {
    let count = 0
    let service = 0
    if (this.props.data.length > 0) {
      this.props.data.forEach((element) => {
        if (count == 0) {
          service += this.state.costoGestion
        }

        if (count >= 2) {
          service += this.state.costoPlus
        }

        count++
      })

      this.setState({
        service: service,
      })

      this.setState({
        countCedula: count,
      })
    }

    return
  }

  isSameTitularToAutorized = () => {
    let subscuit = ''

    if (
      this.props.step2_dni_type == 7 &&
      this.props.a_dni_type != 7 &&
      this.props.a_cuit_cuil.length != 11
    ) {
      subscuit = this.props.t_cuit_cuil
        .replace(/-/g, '')
        .substr(2, this.props.t_cuit_cuil.length)
      subscuit = subscuit.substring(0, subscuit.length - 1)

      return this.props.a_cuit_cuil == subscuit
    }

    if (
      this.props.step2_dni_type == 1 &&
      this.props.a_dni_type != 1 &&
      this.props.t_cuit_cuil != 11
    ) {
      subscuit = this.props.a_cuit_cuil
        .replace(/-/g, '')
        .substr(2, this.props.a_cuit_cuil.length)
      subscuit = subscuit.substring(0, subscuit.length - 1)

      return this.props.t_cuit_cuil == subscuit
    }

    return (
      this.props.t_cuit_cuil.replace(/-/g, '') ==
      this.props.a_cuit_cuil.replace(/-/g, '')
    )
  }

  deleteCedule = (index) => {
    const costoGestion = this.state.costoGestion
    const costoPlus = this.state.costoPlus

    this.props.onDelete(index)

    this.setState({
      countCedula: this.state.countCedula - 1,
    })

    if (this.state.countCedula == 1) {
      this.setState({ countCedula: 0 })
    }

    if (this.state.countCedula > 2) {
      this.setState({ service: this.state.service - costoPlus })
    }

    if (this.state.countCedula == 0) {
      this.setState({ service: this.state.service - costoGestion })
    }
  }

  handleChangeDate = (date) => {
    this.setState({
      valueDate: date,
    })
  }

  setNameDoc = (typeDni) => {
    switch (typeDni) {
      case '1':
        return 'DNI'
      case '2':
        return 'Libreta de Enrolamiento'
      case '3':
        return 'Libreta Cívica'
      case '4':
        return 'DNI Extranjero'
      case '5':
        return 'Cedula de identidad Extranjero'
      case '6':
        return 'Pasaporte'
      case '7':
        return 'CUIT/CUIL'
      default:
        return 'DNI'
    }
  }

  setNameProduct = (type) => {
    switch (type) {
      case 'cedula-azul':
        return 'EXPEDICIÓN CÉDULA AZUL'
      case 'renovate-cedula-verde':
        return 'RENOVACIÓN POR VENCIMIENTO CÉDULA VERDE'
      case 'duplicate-cedula-verde':
        return 'DUPLICADO DE CÉDULA VERDE'
      case 'cedula-verde':
        return 'EXPEDICIÓN ADICIONAL DE CÉDULA VERDE'
      case 'revocacion-cedula-azul':
        return 'REVOCADO CEDULA AZUL'
      default:
        return 'EXPEDICIÓN CÉDULA AZUL'
    }
  }

  renderInput = (field) => <TextField field={field} />

  renderSelect = (field) => <SelectField field={field} />

  renderOptionsDnis = () => {
    return this.state.selectedTypes.map((item, index) => (
      <option value={item.id} key={item.id}>
        {item.type}
      </option>
    ))
  }

  handleJuridica = (event) => {
    this.props.changeType('fisica')
    this.setState({
      selectedTypes: this.state.typesDniJuridica,
    })
    this.setState({
      typePerson: 'juridica',
    })
  }

  handleFisica = (event) => {
    this.props.changeType('juridica')
    this.setState({
      selectedTypes: this.state.typesDniFisica,
    })
    this.setState({
      typePerson: 'fisica',
    })
  }

  handleAccepted = (event) => {
    this.setState({
      accepted: true,
    })
  }

  handNotAccepted = (event) => {
    this.setState({
      accepted: false,
    })
  }

  handleTypeDniChoise = async (event) => {
    if (this.props.a_dni_type == '7') {
      try {
        const resp = await getFullnameByCuit(event.target.value)
        this.props.change('a_fullname', resp.data.p_razon_social)
      } catch (error) {
        console.log(error)
      }
    }
  }

  handleKeyDown = (e, cb) => {
    if (e.key === 'Enter' && e.shiftKey === false) {
      e.preventDefault()
      cb()
    }
  }

  handleDateChangeRaw = (e) => {
    e.preventDefault()
  }

  excludeDates = () => {
    const exclude = excludes
    return exclude
  }

  existSameDocNumber = (type, number) => {
    const exist = this.props.data.filter((data) => {
      return data.cuitCuil == number && data.dniType == type
    })

    if (exist.length > 0) {
      return true
    }

    return false
  }

  getDataServicesCedula = () => {
    let data = {
      patent: this.props.patent,
      chasis: this.props.chasis,
      product: this.props.product,
      cost: this.state.service,
      turnDate: this.state.valueDate,
      solicitante: {
        caracter: this.props.step1_caracter,
        cuit: this.props.step1_cuit,
        fullname: this.props.step1_fullname,
        email: this.props.step1_email,
        codeArea: '11',
        phone: '1111111',
        operador: 'personal',
      },
      titular: {
        typePerson: this.state.typePerson,
        docType: this.setNameDoc(this.props.step2_dni_type),
        codNumber:
          this.props.t_cuit_cuil.length === 7 &&
          this.props.step2_dni_type == '1'
            ? `0${this.props.t_cuit_cuil}`
            : this.props.t_cuit_cuil,
      },
      cedulas: this.props.data,
    }
    return data
  }

  getDataServicesRenovation = () => {
    let data = {
      patent: this.props.patent,
      chasis: this.props.chasis,
      product: this.props.product,
      cost: this.state.costoGestion,
      turnDate: this.state.valueDate,
      solicitante: {
        caracter: this.props.step1_caracter,
        cuit: this.props.step1_cuit,
        fullname: this.props.step1_fullname,
        email: this.props.step1_email,
        codeArea: '11',
        phone: '1111111',
        operador: 'personal',
      },
      titular: {
        typePerson: this.state.typePerson,
        docType: this.setNameDoc(this.props.step2_dni_type),
        codNumber:
          this.props.t_cuit_cuil.length === 7 &&
          this.props.step2_dni_type == '1'
            ? `0${this.props.t_cuit_cuil}`
            : this.props.t_cuit_cuil,
      },
      cedulas: null,
    }

    return data
  }

  getDataDuplicate = () => {
    let data = {
      patent: this.props.patent,
      chasis: this.props.chasis,
      product: this.props.product,
      cost: this.state.costoGestion,
      turnDate: this.state.valueDate,
      motive: this.props.step2_motive,
      solicitante: {
        caracter: this.props.step1_caracter,
        cuit: this.props.step1_cuit,
        fullname: this.props.step1_fullname,
        email: this.props.step1_email,
        codeArea: '11',
        phone: '1111111',
        operador: 'personal',
      },
      titular: {
        typePerson: this.state.typePerson,
        docType: this.setNameDoc(this.props.step2_dni_type),
        codNumber:
          this.props.t_cuit_cuil.length === 7 &&
          this.props.step2_dni_type == '1'
            ? `0${this.props.t_cuit_cuil}`
            : this.props.t_cuit_cuil,
      },
      cedulas: null,
    }

    return data
  }

  getDataServices = () => {
    if (
      this.props.product == 'cedula-azul' ||
      this.props.product == 'revocacion-cedula-azul' ||
      this.props.product == 'cedula-verde'
    ) {
      return this.getDataServicesCedula()
    }

    if (this.props.product == 'renovate-cedula-verde') {
      return this.getDataServicesRenovation()
    }

    if (this.props.product == 'duplicate-cedula-verde') {
      return this.getDataDuplicate()
    }
  }

  caclPayToCedula = (
    arancel,
    formulario13,
    expCedulaAutorizar,
    cant,
    multa = 0
  ) => {
    if (this.state.showExpedicionCedulaVerde) {
      return expCedulaAutorizar * cant + (arancel + multa + formulario13)
    }

    return expCedulaAutorizar * cant + arancel
  }

  handleSubmitStepTwo = () => {
    if (this.props.product == 'duplicate-cedula-verde') {
      if (
        this.props.step2_motive == null ||
        this.props.step2_motive.length == 0 ||
        /^\s*$/.test(this.props.step2_motive)
      ) {
        this.setState({
          showErrorNotMotive: true,
        })

        return
      }
    }

    if (
      this.checkCorrectData(this.props.step2_dni_type, this.props.t_cuit_cuil)
    )
      return

    if (this.props.data.length === 0 && this.state.showExpediciónCedula) {
      this.setState({
        showError: true,
      })

      return
    }

    if (this.state.accepted === false) {
      this.setState({
        showErrorNotAccepted: true,
      })

      return
    }

    if (this.state.valueDate == '') {
      this.setState({
        showErrorNoDate: true,
      })

      return
    }

    const gclid = JSON.parse(localStorage.getItem('gclid'))

    let cedula = this.getDataServices()

    cedula.gclid = gclid ? gclid.value : null

    Swal.fire({
      title: 'Estas a un paso de completar el tramite!',
      onBeforeOpen: () => {
        Swal.showLoading()
        return axios
          .post(`${config.serverUrl}/store`, { cedula })
          .then((res) => {
            setTimeout(() => {
              window.location.href = res.data.data.url
            }, 3000)
          })
          .catch((error) => {
            Swal.showValidationMessage(`Envío fallido disculpe: ${error}`)
          })
      },
    })
  }

  render() {
    const { handleSubmit } = this.props

    return (
      <Form
        onKeyDown={(e) => {
          this.handleKeyDown(e, this.handleAddCedule)
        }}
        onSubmit={(e) => {
          e.preventDefault()
          e.stopPropagation()
          this.handleSubmitStepTwo()
        }}>
        <div className='d-flex flex-wrap'>
          <div className='col-md-12 mb-3'>
            <Col
              md={{ size: 6, offset: 3 }}
              className='d-flex justify-content-between mb-2'
              style={{ flex: 1 }}>
              <LabelStyled check>
                <Input
                  type='radio'
                  name='step2_radio1'
                  value='fisica'
                  onChange={(e) => this.handleFisica(e)}
                  checked={this.props.type == 'juridica'}
                />{' '}
                Persona Fisica
              </LabelStyled>
              <LabelStyled>
                <Input
                  type='radio'
                  name='step2_radio2'
                  value='juridica'
                  onChange={(e) => this.handleJuridica(e)}
                  checked={this.props.type == 'fisica'}
                />{' '}
                Persona Juridica
              </LabelStyled>
            </Col>
          </div>

          <div className='col-md-4'>
            <div className='form-group'>
              <FieldStyled
                className='form-control'
                name='step2_dni_type'
                validate={required}
                component={this.renderSelect}
                onChange={this.handleChangeDni}
                options={
                  <Fragment>
                    <option value=''>Tipo de Documento*</option>
                    {this.renderOptionsDnis()}
                  </Fragment>
                }
              />
            </div>
          </div>

          <div className='col-md-8'>
            <div className='form-group'>
              <FieldStyled
                className='form-control'
                name='t_cuit_cuil'
                validate={[required, this.validateDniOne]}
                component={this.renderInput}
                placeholder='Nro Documento*'
              />
            </div>
          </div>

          {this.state.showDuplicateCedulaVerde && (
            <Fragment>
              <div className='col-md-12'>
                <div className='form-group'>
                  <FieldStyled
                    className='form-control'
                    name='step2_motive'
                    validate={required}
                    component={this.renderSelect}
                    options={
                      <Fragment>
                        <option value=''>Motivo*</option>
                        <option value='extravio'>EXTRAVIO</option>
                        <option value='robo'>ROBO Y/O HURTO</option>
                        <option value='deterioro'>DETERIORO</option>
                        <option value='destruccion'>DESTRUCCIÓN</option>
                      </Fragment>
                    }
                  />
                </div>
              </div>
            </Fragment>
          )}

          {this.state.showExpedicionCedulaVerde && (
            <Fragment>
              <div className='col-md-12'>
                <StyledTitle
                  align='center'
                  className='mt-4 mb-4 py-1 font-size-mobile-title'
                  background='#F2F2F2'>
                  DATOS DE CEDULA VERDE ADICIONAL
                </StyledTitle>
              </div>

              <div className='col-md-4'>
                <div className='form-group'>
                  <FieldStyled
                    className='form-control'
                    name='a_dni_type'
                    component={this.renderSelect}
                    onChange={this.handleChangeADni}
                    options={
                      <Fragment>
                        <option value=''>Tipo de Documento*</option>
                        <option value='1'>DNI</option>
                        <option value='2'>Libreta de Enrolamiento</option>
                        <option value='3'>Libreta Cívica</option>
                        <option value='4'>DNI Extranjero</option>
                        <option value='5'>
                          Cedula de identidad Extranjero
                        </option>
                        <option value='6'>Pasaporte</option>
                        <option value='7'>CUIT / CUIL</option>
                      </Fragment>
                    }
                  />
                </div>
              </div>

              <div className='col-md-8'>
                <div className='form-group'>
                  <FieldStyled
                    className='form-control'
                    name='a_cuit_cuil'
                    onBlur={this.handleTypeDniChoise}
                    validate={[required, this.validateDniTwo]}
                    component={this.renderInput}
                    placeholder='Nro Documento*'
                  />
                </div>
              </div>

              <div className='col-md-6'>
                <div className='form-group'>
                  <FieldStyled
                    className='form-control'
                    name='a_firstname'
                    component={this.renderInput}
                    placeholder='Nombres Completos*'
                  />
                </div>
              </div>

              <div className='col-md-6'>
                <div className='form-group'>
                  <FieldStyled
                    className='form-control'
                    name='a_lastname'
                    component={this.renderInput}
                    placeholder='Apellidos Completos*'
                  />
                </div>
              </div>

              <div className='col-md-12 justify-content-center d-flex mb-2'>
                <StyledButton
                  disabled={
                    !this.props.a_cuit_cuil ||
                    !this.props.a_dni_type ||
                    !this.props.a_firstname ||
                    !this.props.a_lastname
                  }
                  onClick={(e) => this.handleAddCedule(e)}
                  className={
                    this.props.data.length > 0
                      ? 'mr-2 btn-style-add-one'
                      : 'mr-2'
                  }
                  type='button'
                  color='info'>
                  {'AGREGAR CEDULA'}
                </StyledButton>
              </div>
              <p
                style={{
                  width: '100%',
                  textAlign: 'center',
                  fontSize: '15px',
                  color: '#000000',
                  marginBottom: '3px',
                }}>
                Puede cargar todas las cedulas que necesite en esta pantalla.
              </p>
              <p
                style={{
                  width: '100%',
                  textAlign: 'center',
                  fontSize: '15px',
                  color: '#000000',
                }}>
                El precio de gestión corresponde hasta 2 cédulas, a partir de la
                3ra se cobrará $50 adicionales por c/u.
              </p>

              {this.state.showErrorCed && (
                <Paragraph className='pr-3 d-flex justify-content-center align-items-center text-danger'>
                  <i className='fa fa-exclamation-triangle mr-1' />{' '}
                  <span>
                    {' '}
                    Ya tiene agregado una cedula con el mismo número de
                    documento.
                  </span>
                </Paragraph>
              )}
              <div className='col-md-12 mb-4'>
                <StyledTitle
                  align='center'
                  className='mt-5 py-1 font-size-mobile-title'>
                  CEDULAS SOLICITADAS
                </StyledTitle>
              </div>
              {this.props.data.length > 0 && (
                <Fragment>
                  <div className='col-md-12' style={{ overflowX: 'auto' }}>
                    <TableStyled striped>
                      <thead>
                        <tr>
                          <th>Apellido y Nombre</th>
                          <th>Documento</th>
                          <th>Tipo Cedula</th>
                          <th>Acciones</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.props.data.map((el, index) => (
                          <tr key={index}>
                            <td>{`${el.firstname} ${el.lastname}`}</td>
                            <td>
                              {el.dniType} {el.cuitCuil}
                            </td>
                            <td>
                              {el.typeCedula === 'cedula-azul'
                                ? 'Cedula Azul'
                                : 'Cedula Verde'}
                            </td>
                            <td style={{ textAlign: 'center' }}>
                              <button
                                onClick={() => this.deleteCedule(index)}
                                className='btn p-0'
                                type='button'
                                style={{ backgroundColor: 'transparent' }}>
                                <i
                                  style={{ color: 'red' }}
                                  className='fa fa-trash'
                                />
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </TableStyled>
                  </div>

                  <div className='col-md-12'>
                    <Separator className='d-flex bg-grey py-2 px-2 mb-2'>
                      <p
                        className='label-aprox-registro'
                        style={{ color: '#006ba5' }}>
                        TOTAL APROXIMADO A ABONAR EN EL REGISTRO
                        <Fragment>
                          <StyledInfo
                            onClick={() => this.toggle('Popover3')}
                            id='Popover3'>
                            <i className='fas fa-question-circle' />
                          </StyledInfo>
                          <Popover
                            style={{ fontFamily: 'Montserrat Regular' }}
                            placement='right'
                            isOpen={this.state.popoverOpen['Popover3']}
                            target='Popover3'
                            toggle={() => this.toggle('Popover3')}>
                            <PopoverBody style={{ fontSize: '14px' }}>
                              Los costos pueden variar segun vehículo y registro
                            </PopoverBody>
                          </Popover>
                        </Fragment>
                      </p>
                      <p
                        style={{
                          color: '#006ba5',
                          right: '25px',
                          position: 'absolute',
                        }}>
                        $
                        {this.caclPayToCedula(
                          this.state.arancelCedulaVerde.arancel,
                          this.state.arancelCedulaVerde.formulario13,
                          this.state.arancelCedulaVerde.cedulaAuthorization,
                          this.props.data.length,
                          this.state.arancelCedulaVerde.multa
                        )}
                        .-
                      </p>
                    </Separator>
                    <Separator className='d-flex bg-grey py-2 px-2 mb-2'>
                      <p style={{ color: '#000' }}>TOTAL COSTO GESTIÓN</p>
                      <Fragment>
                        <StyledInfo
                          onClick={() => this.toggle('Popover2')}
                          id='Popover2'>
                          <i className='fas fa-question-circle' />
                        </StyledInfo>
                        <Popover
                          style={{ fontFamily: 'Montserrat Regular' }}
                          placement='right'
                          isOpen={this.state.popoverOpen['Popover2']}
                          target='Popover2'
                          toggle={() => this.toggle('Popover2')}>
                          <PopoverBody style={{ fontSize: '14px' }}>
                            El precio de gestión corresponde hasta 2 cédulas, a
                            partir de la 3ra se cobrará $50 adicionales por c/u.
                          </PopoverBody>
                        </Popover>
                      </Fragment>
                      <p
                        style={{
                          color: '#000',
                          right: '25px',
                          position: 'absolute',
                        }}>
                        ${this.state.service}.-
                      </p>
                    </Separator>
                  </div>
                  <div className='col-md-12'>
                    <Separator className='d-flex bg-grey py-2 px-2 mb-2 justify-content align-items-center'>
                      <p style={{ margin: '20px' }}>Turno:</p>
                      <DatePicker
                        className='date-picker-custom'
                        minDate={this.state.minDate}
                        maxDate={this.state.maxDate}
                        excludeDates={this.excludeDates()}
                        dateFormat='dd/MM/yyyy'
                        placeholderText='Fecha del turno'
                        onChangeRaw={this.handleDateChangeRaw}
                        selected={this.state.valueDate}
                        onChange={this.handleChangeDate}
                      />
                      <Fragment>
                        <StyledInfo
                          onClick={() => this.toggle('Popover4')}
                          id='Popover4'>
                          <i className='fas fa-question-circle' />
                        </StyledInfo>
                        <Popover
                          style={{ fontFamily: 'Montserrat Regular' }}
                          placement='right'
                          isOpen={this.state.popoverOpen['Popover4']}
                          target='Popover4'
                          toggle={() => this.toggle('Popover4')}>
                          <PopoverBody style={{ fontSize: '14px' }}>
                            La fecha de turno esta sostenido a disponibilidad en
                            el registro.
                          </PopoverBody>
                        </Popover>
                      </Fragment>
                    </Separator>
                  </div>
                </Fragment>
              )}
            </Fragment>
          )}

          {(this.state.showExpediciónCedula ||
            this.state.showRevocCedulaAzul) && (
            <Fragment>
              <div className='col-md-12'>
                <StyledTitle
                  align='center'
                  className='mt-4 mb-4 py-1 font-size-mobile-title'
                  background='#F2F2F2'>
                  {this.props.product == 'revocacion-cedula-azul'
                    ? 'DATOS DE CEDULA AZUL/REVOCACION'
                    : 'DATOS DE CEDULA AZUL/AUTORIZADO'}
                </StyledTitle>
              </div>

              <div className='col-md-4'>
                <div className='form-group'>
                  <FieldStyled
                    className='form-control'
                    name='a_dni_type'
                    component={this.renderSelect}
                    onChange={this.handleChangeADni}
                    options={
                      <Fragment>
                        <option value=''>Tipo de Documento*</option>
                        <option value='1'>DNI</option>
                        <option value='2'>Libreta de Enrolamiento</option>
                        <option value='3'>Libreta Cívica</option>
                        <option value='4'>DNI Extranjero</option>
                        <option value='5'>
                          Cedula de identidad Extranjero
                        </option>
                        <option value='6'>Pasaporte</option>
                        <option value='7'>CUIT / CUIL</option>
                      </Fragment>
                    }
                  />
                </div>
              </div>

              <div className='col-md-8'>
                <div className='form-group'>
                  <FieldStyled
                    className='form-control'
                    name='a_cuit_cuil'
                    onBlur={this.handleTypeDniChoise}
                    validate={[required, this.validateDniTwo]}
                    component={this.renderInput}
                    placeholder='Nro Documento*'
                  />
                </div>
              </div>

              <div className='col-md-6'>
                <div className='form-group'>
                  <FieldStyled
                    className='form-control'
                    name='a_firstname'
                    component={this.renderInput}
                    placeholder='Nombres Completos*'
                  />
                </div>
              </div>

              <div className='col-md-6'>
                <div className='form-group'>
                  <FieldStyled
                    className='form-control'
                    name='a_lastname'
                    component={this.renderInput}
                    placeholder='Apellidos Completos*'
                  />
                </div>
              </div>

              <div className='col-md-12 justify-content-center d-flex mb-2'>
                <StyledButton
                  disabled={
                    !this.props.a_cuit_cuil ||
                    !this.props.a_dni_type ||
                    !this.props.a_firstname ||
                    !this.props.a_lastname
                  }
                  onClick={(e) => this.handleAddCedule(e)}
                  className={
                    this.props.data.length > 0
                      ? 'mr-2 btn-style-add-one'
                      : 'mr-2'
                  }
                  type='button'
                  color='info'>
                  {'AGREGAR CEDULA'}
                </StyledButton>
              </div>
              <p
                style={{
                  width: '100%',
                  textAlign: 'center',
                  fontSize: '15px',
                  color: '#000000',
                  marginBottom: '3px',
                }}>
                Puede cargar todas las cedulas que necesite en esta pantalla.
              </p>
              <p
                style={{
                  width: '100%',
                  textAlign: 'center',
                  fontSize: '15px',
                  color: '#000000',
                }}>
                El precio de gestión corresponde hasta 2 cédulas, a partir de la
                3ra se cobrará $50 adicionales por c/u.
              </p>

              {this.state.showErrorCed && (
                <Paragraph className='pr-3 d-flex justify-content-center align-items-center text-danger'>
                  <i className='fa fa-exclamation-triangle mr-1' />{' '}
                  <span>
                    {' '}
                    Ya tiene agregado una cedula con el mismo número de
                    documento.
                  </span>
                </Paragraph>
              )}
              <div className='col-md-12 mb-3'>
                <StyledTitle
                  align='center'
                  className='mt-3 py-1 font-size-mobile-title'>
                  CEDULAS SOLICITADAS
                </StyledTitle>
              </div>
              {this.props.data.length > 0 && (
                <Fragment>
                  <div className='col-md-12' style={{ overflowX: 'auto' }}>
                    <TableStyled striped>
                      <thead>
                        <tr>
                          <th>Apellido y Nombre</th>
                          <th>Documento</th>
                          <th>Tipo Cedula</th>
                          <th>Acciones</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.props.data.map((el, index) => (
                          <tr key={index}>
                            <td>{`${el.firstname} ${el.lastname}`}</td>
                            <td>
                              {el.dniType} {el.cuitCuil}
                            </td>
                            <td>
                              {el.typeCedula === 'cedula-azul'
                                ? 'Cedula Azul'
                                : 'Cedula Verde'}
                            </td>
                            <td style={{ textAlign: 'center' }}>
                              <button
                                onClick={() => this.deleteCedule(index)}
                                className='btn p-0'
                                type='button'
                                style={{ backgroundColor: 'transparent' }}>
                                <i
                                  style={{ color: 'red' }}
                                  className='fa fa-trash'
                                />
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </TableStyled>
                  </div>

                  <div className='col-md-12'>
                    <Separator className='d-flex bg-grey py-2 px-2 mb-2'>
                      <p
                        className='label-aprox-registro'
                        style={{ color: '#006ba5' }}>
                        TOTAL APROXIMADO A ABONAR EN EL REGISTRO
                        <Fragment>
                          <StyledInfo
                            onClick={() => this.toggle('Popover3')}
                            id='Popover3'>
                            <i className='fas fa-question-circle' />
                          </StyledInfo>
                          <Popover
                            style={{ fontFamily: 'Montserrat Regular' }}
                            placement='right'
                            isOpen={this.state.popoverOpen['Popover3']}
                            target='Popover3'
                            toggle={() => this.toggle('Popover3')}>
                            <PopoverBody style={{ fontSize: '14px' }}>
                              Los costos pueden variar segun vehículo y registro
                            </PopoverBody>
                          </Popover>
                        </Fragment>
                      </p>
                      <p
                        style={{
                          color: '#006ba5',
                          right: '25px',
                          position: 'absolute',
                        }}>
                        $
                        {this.caclPayToCedula(
                          this.state.expeditionCedulaAzul.arancel,
                          this.state.expeditionCedulaAzulformulario13,
                          this.state.expeditionCedulaAzul.cedulaAuthorization,
                          this.props.data.length,
                          this.state.expeditionCedulaAzul.debt
                        )}
                        .-
                      </p>
                    </Separator>
                    <Separator className='d-flex bg-grey py-2 px-2 mb-2'>
                      <p style={{ color: '#000' }}>TOTAL COSTO GESTIÓN</p>
                      <Fragment>
                        <StyledInfo
                          onClick={() => this.toggle('Popover2')}
                          id='Popover2'>
                          <i className='fas fa-question-circle' />
                        </StyledInfo>
                        <Popover
                          style={{ fontFamily: 'Montserrat Regular' }}
                          placement='right'
                          isOpen={this.state.popoverOpen['Popover2']}
                          target='Popover2'
                          toggle={() => this.toggle('Popover2')}>
                          <PopoverBody style={{ fontSize: '14px' }}>
                            El precio de gestión corresponde hasta 2 cédulas, a
                            partir de la 3ra se cobrará $50 adicionales por c/u.
                          </PopoverBody>
                        </Popover>
                      </Fragment>
                      <p
                        style={{
                          color: '#000',
                          right: '25px',
                          position: 'absolute',
                        }}>
                        ${this.state.service}.-
                      </p>
                    </Separator>
                  </div>
                  <div className='col-md-12'>
                    <Separator className='d-flex bg-grey py-2 px-2 mb-2 justify-content align-items-center'>
                      <p style={{ margin: '20px' }}>Turno:</p>
                      <DatePicker
                        className='date-picker-custom'
                        minDate={this.state.minDate}
                        maxDate={this.state.maxDate}
                        excludeDates={this.excludeDates()}
                        dateFormat='dd/MM/yyyy'
                        placeholderText='Fecha del turno'
                        onChangeRaw={this.handleDateChangeRaw}
                        selected={this.state.valueDate}
                        onChange={this.handleChangeDate}
                      />
                      <Fragment>
                        <StyledInfo
                          onClick={() => this.toggle('Popover4')}
                          id='Popover4'>
                          <i className='fas fa-question-circle' />
                        </StyledInfo>
                        <Popover
                          style={{ fontFamily: 'Montserrat Regular' }}
                          placement='right'
                          isOpen={this.state.popoverOpen['Popover4']}
                          target='Popover4'
                          toggle={() => this.toggle('Popover4')}>
                          <PopoverBody style={{ fontSize: '14px' }}>
                            La fecha de turno esta sostenido a disponibilidad en
                            el registro.
                          </PopoverBody>
                        </Popover>
                      </Fragment>
                    </Separator>
                  </div>
                </Fragment>
              )}
            </Fragment>
          )}

          {this.state.showErrorSameTitAuth && (
            <div className='col-md-12'>
              <Paragraph className='pr-3 d-flex justify-content-center align-items-center text-danger'>
                <i className='fa fa-exclamation-triangle mr-1' />{' '}
                <span style={{ textAlign: 'center' }}>
                  {' '}
                  Los datos del autorizado no pueden ser los mismos que los
                  datos del titular.
                </span>
              </Paragraph>
            </div>
          )}

          {this.state.showRenovationCedulaVerde && (
            <Fragment>
              <div className='col-md-12'>
                <Separator className='d-flex bg-grey py-2 px-2 mb-2'>
                  <p
                    className='label-aprox-registro'
                    style={{ color: '#006ba5' }}>
                    TOTAL APROXIMADO A ABONAR EN EL REGISTRO
                    <Fragment>
                      <StyledInfo
                        onClick={() => this.toggle('Popover3')}
                        id='Popover3'>
                        <i className='fas fa-question-circle' />
                      </StyledInfo>
                      <Popover
                        style={{ fontFamily: 'Montserrat Regular' }}
                        placement='right'
                        isOpen={this.state.popoverOpen['Popover3']}
                        target='Popover3'
                        toggle={() => this.toggle('Popover3')}>
                        <PopoverBody style={{ fontSize: '14px' }}>
                          Los costos pueden variar segun vehículo y registro
                        </PopoverBody>
                      </Popover>
                    </Fragment>
                  </p>
                  <p
                    style={{
                      color: '#006ba5',
                      right: '25px',
                      position: 'absolute',
                    }}>
                    $
                    {this.state.arancelCedulaVerde.arancel +
                      this.state.arancelCedulaVerde.formulario13 +
                      this.state.arancelCedulaVerde.cedulaAuthorization +
                      this.state.arancelCedulaVerde.multa}
                  </p>
                </Separator>
                <Separator className='d-flex bg-grey py-2 px-2 mb-2'>
                  <p style={{ color: '#000' }}>TOTAL COSTO GESTIÓN</p>
                  <Fragment>
                    <StyledInfo
                      onClick={() => this.toggle('Popover2')}
                      id='Popover2'>
                      <i className='fas fa-question-circle' />
                    </StyledInfo>
                    <Popover
                      style={{ fontFamily: 'Montserrat Regular' }}
                      placement='right'
                      isOpen={this.state.popoverOpen['Popover2']}
                      target='Popover2'
                      toggle={() => this.toggle('Popover2')}>
                      <PopoverBody style={{ fontSize: '14px' }}>
                        Solo abona el costo de gestión.
                      </PopoverBody>
                    </Popover>
                  </Fragment>

                  <p
                    style={{
                      color: '#000',
                      right: '25px',
                      position: 'absolute',
                    }}>
                    ${this.state.costoGestion}.-
                  </p>
                </Separator>

                <Separator className='d-flex bg-grey py-2 px-2 mb-2 justify-content align-items-center'>
                  <p style={{ margin: '20px' }}>Turno:</p>
                  <DatePicker
                    className='date-picker-custom'
                    minDate={this.state.minDate}
                    excludeDates={this.excludeDates()}
                    maxDate={this.state.maxDate}
                    dateFormat='dd/MM/yyyy'
                    placeholderText='Fecha del turno'
                    onChangeRaw={this.handleDateChangeRaw}
                    selected={this.state.valueDate}
                    onChange={this.handleChangeDate}
                  />
                  <Fragment>
                    <StyledInfo
                      onClick={() => this.toggle('Popover4')}
                      id='Popover4'>
                      <i className='fas fa-question-circle' />
                    </StyledInfo>
                    <Popover
                      style={{ fontFamily: 'Montserrat Regular' }}
                      placement='right'
                      isOpen={this.state.popoverOpen['Popover4']}
                      target='Popover4'
                      toggle={() => this.toggle('Popover4')}>
                      <PopoverBody style={{ fontSize: '14px' }}>
                        La fecha de turno esta sostenido a disponibilidad en el
                        registro.
                      </PopoverBody>
                    </Popover>
                  </Fragment>
                </Separator>
              </div>
            </Fragment>
          )}

          {this.state.showDuplicateCedulaVerde && (
            <Fragment>
              <div className='col-md-12'>
                <Separator className='d-flex bg-grey py-2 px-2 mb-2'>
                  <p
                    className='label-aprox-registro'
                    style={{ color: '#006ba5' }}>
                    TOTAL APROXIMADO A ABONAR EN EL REGISTRO
                    <Fragment>
                      <StyledInfo
                        onClick={() => this.toggle('Popover3')}
                        id='Popover3'>
                        <i className='fas fa-question-circle' />
                      </StyledInfo>
                      <Popover
                        style={{ fontFamily: 'Montserrat Regular' }}
                        placement='right'
                        isOpen={this.state.popoverOpen['Popover3']}
                        target='Popover3'
                        toggle={() => this.toggle('Popover3')}>
                        <PopoverBody style={{ fontSize: '14px' }}>
                          Los costos pueden variar segun vehículo y registro
                        </PopoverBody>
                      </Popover>
                    </Fragment>
                  </p>
                  <p
                    style={{
                      color: '#006ba5',
                      right: '25px',
                      position: 'absolute',
                    }}>
                    ${' '}
                    {this.state.arancelCedulaVerde.arancel +
                      this.state.arancelCedulaVerde.formulario13 +
                      this.state.arancelCedulaVerde.cedulaAuthorization +
                      this.state.arancelCedulaVerde.multa}
                    .-
                  </p>
                </Separator>
                <Separator className='d-flex bg-grey py-2 px-2 mb-2'>
                  <p className='label-aprox-registro' style={{ color: '#000' }}>
                    COSTO DE GESTIÓN
                  </p>
                  <Fragment>
                    <StyledInfo
                      onClick={() => this.toggle('Popover2')}
                      id='Popover2'>
                      <i className='fas fa-question-circle' />
                    </StyledInfo>
                    <Popover
                      style={{ fontFamily: 'Montserrat Regular' }}
                      placement='right'
                      isOpen={this.state.popoverOpen['Popover2']}
                      target='Popover2'
                      toggle={() => this.toggle('Popover2')}>
                      <PopoverBody style={{ fontSize: '14px' }}>
                        Solo abona el costo de gestión.
                      </PopoverBody>
                    </Popover>
                  </Fragment>
                  <p
                    style={{
                      color: '#000',
                      right: '25px',
                      position: 'absolute',
                    }}>
                    ${this.state.costoGestion}.-
                  </p>
                </Separator>
                <Separator className='d-flex bg-grey py-2 px-2 mb-2 justify-content align-items-center'>
                  <p style={{ margin: '20px' }}>Turno:</p>
                  <DatePicker
                    className='date-picker-custom'
                    minDate={this.state.minDate}
                    maxDate={this.state.maxDate}
                    excludeDates={this.excludeDates()}
                    dateFormat='dd/MM/yyyy'
                    placeholderText='Fecha del turno'
                    onChangeRaw={this.handleDateChangeRaw}
                    selected={this.state.valueDate}
                    onChange={this.handleChangeDate}
                  />
                  <Fragment>
                    <StyledInfo
                      onClick={() => this.toggle('Popover4')}
                      id='Popover4'>
                      <i className='fas fa-question-circle' />
                    </StyledInfo>
                    <Popover
                      style={{ fontFamily: 'Montserrat Regular' }}
                      placement='right'
                      isOpen={this.state.popoverOpen['Popover4']}
                      target='Popover4'
                      toggle={() => this.toggle('Popover4')}>
                      <PopoverBody style={{ fontSize: '14px' }}>
                        La fecha de turno esta sostenido a disponibilidad en el
                        registro.
                      </PopoverBody>
                    </Popover>
                  </Fragment>
                </Separator>
              </div>
            </Fragment>
          )}

          <div className='col-md-10 offset-md-2'>
            <LabelStyled
              style={{
                fontSize: '14px',
                color: '#5d5d5d',
                textAlign: 'justify',
              }}>
              <Input
                type='checkbox'
                name='check3'
                value={this.state.accepted}
                onChange={(e) =>
                  !this.state.accepted
                    ? this.handleAccepted(e)
                    : this.handNotAccepted(e)
                }
              />{' '}
              <p className='disclaimer'>
                He leído y acepto los{' '}
                <a
                  href={`${config.tramitaYa}/politica-privacidad`}
                  target='_blank'>
                  Términos y Condiciones del uso
                </a>{' '}
                que se presentan en este sitio brindando mi conformidad a la
                empresa a prestar el servicio de la gestión de las Cédulas
                correspondientes, conociendo de que este trámite puede
                realizarse ingresando personalmente y sin costo en el sitio de
                la DNRPA y la misma brinda información suficiente para realizar
                dicho trámite en su pagina web.
              </p>
            </LabelStyled>
          </div>

          <div className='col-md-12'>
            {this.state.showError && (
              <Paragraph className='pr-3 d-flex justify-content-center align-items-center text-danger'>
                <i className='fa fa-exclamation-triangle mr-1' />{' '}
                <span> Debe agregar al menos una cedula</span>
              </Paragraph>
            )}

            {this.state.showErrorNotMotive && (
              <Paragraph className='pr-3 d-flex justify-content-center align-items-center text-danger'>
                <i className='fa fa-exclamation-triangle mr-1' />{' '}
                <span> Debe seleccionar el motivo</span>
              </Paragraph>
            )}

            {this.state.showErrorNotAccepted && (
              <Paragraph className='pr-3 d-flex justify-content-center align-items-center text-danger'>
                <i className='fa fa-exclamation-triangle mr-1' />{' '}
                <span>Debe aceptar los términos y condiciones de uso</span>
              </Paragraph>
            )}

            {this.state.showErrorNoDate && (
              <Paragraph className='pr-3 d-flex justify-content-center align-items-center text-danger'>
                <i className='fa fa-exclamation-triangle mr-1' />{' '}
                <span> Debe seleccionar un turno</span>
              </Paragraph>
            )}
          </div>

          <div
            className='col-md-12 d-flex-md justify-content-center d-none d-sm-block'
            style={{ flexDirection: 'column' }}>
            <div className='d-flex justify-content-center mt-3 mb-1 mr-3'>
              <StyledButton type='submit' color='info'>
                {'ENVIAR SOLICITUD >'}
              </StyledButton>
            </div>
            <Paragraph className='d-flex justify-content-center'>
              Abona sólo el servicio de gestión.
            </Paragraph>
          </div>

          <div
            className='col-md-12 d-flex-md justify-content-center d-block d-sm-none'
            style={{ flexDirection: 'column' }}>
            <div className='d-flex justify-content-center mt-3 mb-1 mr-3'>
              <StyledButtonSubmit
                id='btn-solicitud-mobile'
                color='info'
                style={{ width: '100%' }}>
                {'ENVIAR SOLICITUD >'}
              </StyledButtonSubmit>
            </div>
            <Paragraph className='d-flex justify-content-center'>
              Abona sólo el servicio de gestión.
            </Paragraph>
          </div>
        </div>
      </Form>
    )
  }
}

const Separator = styled.div`
  background-color: #eaeaea;

  p {
    font-weight: 700;
    color: #9c9c9c;
    margin: 0;
  }
`

const TableStyled = styled(Table)`
  thead {
    background-color: #30bdbb !important;
    font-size: 13px !important;
  }

  th {
    font-weight: 500;
    color: white;
  }

  th,
  td {
    font-family: Montserrat !important;
    font-weight: bold;
    font-size: 16px !important;
  }
`

const Paragraph = styled.p`
  font-weight: 300 !important;
  color: #9c9c9c;
`

const StyledButton = styled(Button)`
  background: #30bdbb !important;
  border: none !important;
  border-radius: 0 !important;
  padding-top: 10px !important;
  padding-bottom: 10px !important;
  font-family: Montserrat !important;
  font-weight: 600 !important;
  font-size: 21px !important;
`

const StyledButtonAdd = styled(Button)`
  background-color: white !important;
  background: #30bdbb !important;
  border: 1px solid #17a2b8 !important;
  border-width: 3px !important;
  color: #17a2b8 !important;
  padding-top: 10px !important;
  padding-bottom: 10px !important;
  font-family: Montserrat !important;
  font-weight: 600 !important;
  font-size: 21px !important;
`

const StyledButtonSubmit = styled(Button)`
  background: #ff7300 !important;
  border: none !important;
  border-radius: 0 !important;
  padding-top: 10px !important;
  padding-bottom: 10px !important;
  font-family: Montserrat !important;
  font-weight: 600 !important;
  font-size: 21px !important;
`

const LabelStyled = styled(Label)`
  font-family: Montserrat !important;
  font-size: 14px;
`

const StyledInfo = styled.span`
  cursor: pointer;
  margin-left: 10px;
  i {
    font-size: 18px;
    color: #30bdbb;
  }
`

export const FieldStyled = styled(Field)`
  border: 1px solid #30bdbb !important;
  border-radius: 0 !important;
  font-size: 14px !important;
  font-family: Montserrat !important;
`

const mapStateToProps = (state) => {
  return {
    a_dni_type: selector(state, 'a_dni_type'),
    a_cuit_cuil: selector(state, 'a_cuit_cuil'),
    a_firstname: selector(state, 'a_firstname'),
    a_lastname: selector(state, 'a_lastname'),
    product: selector(state, 'product'),
    patent: selector(state, 'patent'),
    chasis: selector(state, 'chasis'),
    step2_radio1: selector(state, 'step2_radio1'),
    step2_radio2: selector(state, 'step2_radio2'),
    step2_dni_type: selector(state, 'step2_dni_type'),
    t_cuit_cuil: selector(state, 't_cuit_cuil'),
    step1_caracter: selector(state, 'step1_caracter'),
    step1_cuit: selector(state, 'step1_cuit'),
    step1_fullname: selector(state, 'step1_fullname'),
    step1_email: selector(state, 'step1_email'),
    step2_motive: selector(state, 'step2_motive'),
  }
}

export default reduxForm({
  form: 'wizard',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(connect(mapStateToProps)(StepTwo))
